import React from "react";
import {
  Grid,
  Typography,
  List,
  Divider,
  ListItemButton,
  ListItemText,
  Paper,
} from "@mui/material";
import request from "../../../utilities/requests";

const HelpMain = ({setTopic}) => {
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    const getData = async () => {
      const result = await request("help");
      if (result.success) {
        setData(result.data);
      }
    };
    getData();
  }, []);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ padding: 20 }}
      direction="column"
      spacing={3}
    >
      <Grid item>
        <Typography variant="h4" align="center">
          Support
        </Typography>
      </Grid>
      <Grid item>
        <Typography align="center">
          Find videos and articles here to help you create, manage, and run your
          events
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Paper elevation={3}>
          <List>
            {data.map((d) => {
              return (
                <>
                  <ListItemButton onClick={() => setTopic(d._id)}>
                    <ListItemText primary={d.name} secondary={d.description} />
                  </ListItemButton>
                  <Divider />
                </>
              );
            })}
          </List>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default HelpMain;
